import { Component, OnInit, Input, SimpleChanges, OnChanges, EventEmitter, Output, Inject, OnDestroy, forwardRef } from '@angular/core';
import { FormGroup, FormControl, Validators} from '@angular/forms';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles 
} from './models/control';
import { GridHeaderModel, GridCellModel, GridRowModel, CellStyles, GridContainerStyle, HeaderStyles } from './models/grid'
import { FieldModel } from './models/field'
import { ToolModel } from './models/tool';
import { Styles, ControlContainerStyles } from './models/style';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { isEqual, isNil, set } from 'lodash-es';
import { GridComponent, ELoadingStatus } from './components/grid.component';
import { BaseComponent } from './components/base.component';
import { WorkBook, read as readExcelFile, writeFile as writeExcelFile, utils as excelUtils } from 'xlsx';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { FootprintManager_ShellService } from './FootprintManager.shell.service';
import { FootprintManager_OperationService } from './FootprintManager.operation.service';
import { FootprintManager_DatasourceService } from './FootprintManager.datasource.index';
import { FootprintManager_FlowService } from './FootprintManager.flow.index';
import { FootprintManager_ReportService } from './FootprintManager.report.index';
import { FootprintManager_LocalizationService } from './FootprintManager.localization.service';
import { FootprintManager_shippingcontents_grid_ComponentContextService } from './FootprintManager.shippingcontents_grid.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './FootprintManager.frontend.types'
import { $frontendTypes as $types} from './FootprintManager.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';


interface IFootprintManager_shippingcontents_gridComponentEntity {
  ShipmentLineId?: number, LicensePlateId?: number, LotId?: number, PackagedId?: number, PackagedAmount?: number, ShipmentLine?: { ExpectedPackagedAmount?: number, OrderLineNumber?: number, ExpectedPackaged?: { ShortName?: string } }, LicensePlate?: { LookupCode?: string, Location?: { Id?: number, Name?: string }, ShippingContainer?: { Id?: number, LookupCode?: string, ParentShippingContainer?: { Id?: number, LookupCode?: string } } }, Lot?: { LookupCode?: string, Material?: { Id?: number, LookupCode?: string }, VendorLot?: { Id?: number, LookupCode?: string, Vat?: string } }, Packaged?: { ShortName?: string }}

interface IFootprintManager_shippingcontents_gridComponentInParams {
  orderId: number, shipmentId: number}


class FootprintManager_shippingcontents_gridComponentRowModel extends GridRowModel {
  grid: FootprintManager_shippingcontents_gridComponent;
  entity: IFootprintManager_shippingcontents_gridComponentEntity;



 // temporarily put required on all edit controls
  override formGroup = new FormGroup({
  });

  override cells = {
    linenumber: null,
    material: null,
    total_expected: null,
    actual_packaged_amount: null,
    licenseplate: null,
    location: null,
    lot: null,
    vendorlot: null,
    shipping_container: null,
    parent_shipping_container: null,
  }



  constructor(
    grid: FootprintManager_shippingcontents_gridComponent,
    private $utils: UtilsService,
private $settings: SettingsValuesService,
private $shell: FootprintManager_ShellService,
private $datasources: FootprintManager_DatasourceService,
private $flows: FootprintManager_FlowService,
private $reports: FootprintManager_ReportService,
private $localization: FootprintManager_LocalizationService,
private $operations: FootprintManager_OperationService,
private $logger: CleanupLoggerService,
private $context: FootprintManager_shippingcontents_grid_ComponentContextService,
) {
    super();

    this.grid = grid;

    this.cells.linenumber = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.linenumber,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.material = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.material,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.total_expected = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.total_expected,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.actual_packaged_amount = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.actual_packaged_amount,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.licenseplate = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.licenseplate,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.location = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.location,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.lot = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.lot,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.vendorlot = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.vendorlot,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.shipping_container = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.shipping_container,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.parent_shipping_container = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.parent_shipping_container,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    
  }

  async $initializeExisting(entity: IFootprintManager_shippingcontents_gridComponentEntity) {
    this.entity = entity;

    this.rowId = [this.entity.ShipmentLineId,this.entity.LicensePlateId,this.entity.LotId,this.entity.PackagedId].join('-');

    await this.$dataLoaded();
  }

  async $initializeNew(entity?: IFootprintManager_shippingcontents_gridComponentEntity) {
    this.isNew = true;

    if (entity) {
      this.entity = entity;
    }
    else {
      this.entity = {};
    }

    this.rowId = [this.entity.ShipmentLineId,this.entity.LicensePlateId,this.entity.LotId,this.entity.PackagedId].join('-');
    await this.$dataLoaded();
    // mark the whole form as dirty, since this is a new row 
    // and even if it is valid, it should have a changed state
    this.formGroup.markAsDirty();
  }

  private $unsubscribe$ = new Subject();
  override destroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  $init() {
  }

  async $dataLoad() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    const $resultKey = {};
    set($resultKey, 'ShipmentLineId',this.entity.ShipmentLineId);
    set($resultKey, 'LicensePlateId',this.entity.LicensePlateId);
    set($resultKey, 'LotId',this.entity.LotId);
    set($resultKey, 'PackagedId',this.entity.PackagedId);
    const inParams = {
      $keys:[$resultKey],
      orderId:  $grid.inParams.orderId ,
      shipmentId:  $grid.inParams.shipmentId ,
      fullTextSearch:  $grid.fullTextSearch ,
    };
    const data = await this.$datasources.SalesOrders.ds_shippingcontents_grid.getByKeys(inParams);
    
    await this.grid.$applyLinkedDatasourcesAndCustomColumns(inParams, data);
      
    this.entity = data.result[0] as IFootprintManager_shippingcontents_gridComponentEntity;
    await this.$dataLoaded();
  }

  async $dataLoaded() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    (this.cells.linenumber.displayControl as TextModel).text = $row.entity.ShipmentLine?.OrderLineNumber?.toString();
    (this.cells.material.displayControl as TextModel).text = $row.entity.Lot?.Material?.LookupCode;
    (this.cells.licenseplate.displayControl as TextModel).text = $row.entity.LicensePlate?.LookupCode;
    (this.cells.location.displayControl as TextModel).text = $row.entity.LicensePlate?.Location?.Name;
    (this.cells.lot.displayControl as TextModel).text = $row.entity.Lot?.LookupCode;
    (this.cells.shipping_container.displayControl as TextModel).text = $row.entity.LicensePlate?.ShippingContainer?.LookupCode;
    (this.cells.parent_shipping_container.displayControl as TextModel).text = $row.entity?.LicensePlate?.ShippingContainer?.ParentShippingContainer?.LookupCode;

    await this.on_row_data_loaded();
  }

  override async refresh() {
    if (this.grid.$hasMissingRequiredInParams) {
      return Promise.resolve(null);
    }
    await this.$dataLoad();
    // grid refresh skipSelf=true, skipParent=false, skipChildren=false  
    this.grid.$refreshEvent.emit();
  }

  override async save() {
    if (this.isNew) {
    } else {
    } 
  }

  override $cellClicked(cellId: string) {
    super.$cellClicked(cellId);
    switch(cellId) {
      case 'material' : {
        this.on_material_clicked();
        break;
      }
      case 'licenseplate' : {
        this.on_licenseplate_clicked();
        break;
      }
      case 'location' : {
        this.on_location_clicked();
        break;
      }
      case 'lot' : {
        this.on_lot_clicked();
        break;
      }
    }
  }

  //#region private flows
  on_row_data_loaded(event = null) {
    return this.on_row_data_loadedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_row_data_loadedInternal(
    $row: FootprintManager_shippingcontents_gridComponentRowModel,
  $grid: FootprintManager_shippingcontents_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_shippingcontents_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  // Set vendor lot column
  if ($utils.isDefined($row.entity.Lot?.VendorLot?.Vat)) {
      $row.cells.vendorlot.displayControl.text = $row.entity.Lot?.VendorLot?.LookupCode + ' ' + $row.entity.Lot.VendorLot.Vat;
  }
  else {
      $row.cells.vendorlot.displayControl.text = $row.entity.Lot?.VendorLot?.LookupCode
  }
  
  // Set expected column
  $row.cells.total_expected.displayControl.text = $row.entity.ShipmentLine?.ExpectedPackagedAmount?.toString() + ' ' +  $row.entity.ShipmentLine?.ExpectedPackaged?.ShortName
  
  
  // Set actual column
  $row.cells.actual_packaged_amount.displayControl.text = $row.entity.PackagedAmount?.toString() + ' ' +  $row.entity.Packaged?.ShortName
  }
  on_material_clicked(event = null) {
    return this.on_material_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_material_clickedInternal(
    $row: FootprintManager_shippingcontents_gridComponentRowModel,
  $grid: FootprintManager_shippingcontents_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_shippingcontents_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  
  
  
  $shell.FootprintManager.opensingle_material_hub({materialId: $row.entity.Lot.Material.Id});
  }
  on_lot_clicked(event = null) {
    return this.on_lot_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_lot_clickedInternal(
    $row: FootprintManager_shippingcontents_gridComponentRowModel,
  $grid: FootprintManager_shippingcontents_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_shippingcontents_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  
  $shell.FootprintManager.opensingle_lot_hub({lotId: $row.entity.LotId});
  }
  on_licenseplate_clicked(event = null) {
    return this.on_licenseplate_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_licenseplate_clickedInternal(
    $row: FootprintManager_shippingcontents_gridComponentRowModel,
  $grid: FootprintManager_shippingcontents_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_shippingcontents_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  
  $shell.FootprintManager.opensingle_licenseplate_hub({licenseplateId: $row.entity.LicensePlateId});
  }
  on_location_clicked(event = null) {
    return this.on_location_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_location_clickedInternal(
    $row: FootprintManager_shippingcontents_gridComponentRowModel,
  $grid: FootprintManager_shippingcontents_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_shippingcontents_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  
  $shell.FootprintManager.opensingle_location_hub({locationId: $row.entity.LicensePlate.Location.Id});
  }
  //#endregion private flows

}


@Component({
  standalone: true,
  imports: [
    SharedModule,
  ],
  selector: 'FootprintManager-shippingcontents_grid',
  templateUrl: './FootprintManager.shippingcontents_grid.component.html'
})
export class FootprintManager_shippingcontents_gridComponent extends BaseComponent implements OnInit, OnChanges, OnDestroy {
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();
  //#endregion Outputs

  entities: IFootprintManager_shippingcontents_gridComponentEntity[];

  pageSize = 10;
  pageSkip = 0;
  totalCount = 0;
  loadingStatus = ELoadingStatus.Loading;


// to stop add from flow
// canAdd = false; //hide add button, check on exitFromLastCell 
// bottomToolbar.addLine.hidden = true; //hide add button, no check on exitFromLastCell 
// bottomToolbar.addLine.control.readOnly = true; //disable add button, check on exitFromLastCell 
 
  
  containerStyles: GridContainerStyle = new GridContainerStyle('cellsWidth', ['compact','fit-content-table']);

  fullTextSearch: string;

  inParams: IFootprintManager_shippingcontents_gridComponentInParams = { orderId: null, shipmentId: null };


  //#region Variables
  //#endregion
  //#region Events
  
  //#endregion

  headers = {
     linenumber: new GridHeaderModel(new HeaderStyles(null, null), 'linenumber', 'Line #', false, false, null, false),       material: new GridHeaderModel(new HeaderStyles(null, null), 'material', 'Material', false, false, null, false),       total_expected: new GridHeaderModel(new HeaderStyles(null, null), 'total_expected', 'Total expected', false, false, null, false),       actual_packaged_amount: new GridHeaderModel(new HeaderStyles(null, null), 'actual_packaged_amount', 'Actual', false, false, null, false),       licenseplate: new GridHeaderModel(new HeaderStyles(null, null), 'licenseplate', 'License plate', false, false, null, false),       location: new GridHeaderModel(new HeaderStyles(null, null), 'location', 'Current location', false, false, null, false),       lot: new GridHeaderModel(new HeaderStyles(null, null), 'lot', 'Lot', false, false, null, false),       vendorlot: new GridHeaderModel(new HeaderStyles(null, null), 'vendorlot', 'Vendor lot', false, false, null, false),       shipping_container: new GridHeaderModel(new HeaderStyles(null, null), 'shipping_container', 'Container', false, false, null, false),       parent_shipping_container: new GridHeaderModel(new HeaderStyles(null, null), 'parent_shipping_container', 'Parent container', false, false, null, false),  
  };

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  rows: FootprintManager_shippingcontents_gridComponentRowModel[] = [];

  @Input('orderId') set $inParams_orderId(value: any) {
    this.inParams['orderId'] = value;
  }
  get $inParams_orderId(): any {
    return this.inParams['orderId'] ;
  }
  @Input('shipmentId') set $inParams_shipmentId(value: any) {
    this.inParams['shipmentId'] = value;
  }
  get $inParams_shipmentId(): any {
    return this.inParams['shipmentId'] ;
  }

  topToolbar = {
      unpick: new ToolModel(new ButtonModel('unpick', new ButtonStyles(null, null), false, false, false, 'Unpick', 'icon-ic_fluent_arrow_step_back_20_regular', null)
    , false),
      unload: new ToolModel(new ButtonModel('unload', new ButtonStyles(null, null), false, false, false, 'Unload', 'icon-ic_fluent_cube_arrow_curve_down_20_regular', null)
    , false),
      transfer_to_new_order: new ToolModel(new ButtonModel('transfer_to_new_order', new ButtonStyles(null, null), false, false, false, 'Transfer', 'icon-ic_fluent_arrow_bidirectional_left_right_20_regular', null)
    , false)
  };

  bottomToolbar = {
  };




  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    private $shell: FootprintManager_ShellService,
    private $datasources: FootprintManager_DatasourceService,
    private $flows: FootprintManager_FlowService,
    private $reports: FootprintManager_ReportService,
    private $localization: FootprintManager_LocalizationService,
    private $operations: FootprintManager_OperationService,
    private $logger: CleanupLoggerService,
    private $context: FootprintManager_shippingcontents_grid_ComponentContextService,
    ) {
    super();
    this.title = 'Shipping contents';
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$checkRequiredInParams();
    if (!this.$hasMissingRequiredInParams) {
      this.$init();
    } else {
      this.$initEmpty();
    }
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$checkRequiredInParams();
      if(!this.$hasMissingRequiredInParams) {
        this.$init();
      } else {
        this.$initEmpty();
      }
    }
  }

  $missingRequiredInParams = [];
  get $hasMissingRequiredInParams(): boolean {
    return !!this.$missingRequiredInParams.length;
  }
  
  $checkRequiredInParams() {
    this.$missingRequiredInParams = [];
      if(isNil(this.inParams.orderId)) {
        this.$missingRequiredInParams.push('orderId');
      }
      if(isNil(this.inParams.shipmentId)) {
        this.$missingRequiredInParams.push('shipmentId');
      }
  }

  initialized = false;

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();

    this.clearRows();
  }

  async $init() {
    const $grid = this;
    const $utils = this.$utils;

    this.pageSize = 10;


    await this.on_init();
    this.initialized = true;

    this.pageSkip = 0;
    this.refresh(true, true, null);
  }

  protected override $initEmpty() {
    this.clearRows();
  }

  private $subscribeFormControlValueChanges() {

  }

  reload() {
    this.pageSkip = 0;
    this.refresh();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    if (this.$hasMissingRequiredInParams) {
      return Promise.resolve(null);
    }
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = this.$dataLoad();

    // children
    if (skipChildren === false) {
    }

    return result;
  }

  async $dataLoad() {
    this.loadingStatus = ELoadingStatus.Loading;
    const $grid = this;
    const $utils = this.$utils;
    const inParams = {
      $top: this.pageSize,
      $skip: this.pageSkip,
      orderId:  $grid.inParams.orderId ,
      shipmentId:  $grid.inParams.shipmentId ,
      fullTextSearch:  $grid.fullTextSearch ,
    };
    try {
      const data = await this.$datasources.SalesOrders.ds_shippingcontents_grid.getList(inParams);
      
      await this.$applyLinkedDatasourcesAndCustomColumns(inParams, data);

      this.entities = data.result as IFootprintManager_shippingcontents_gridComponentEntity[];
      this.totalCount = data.totalCount;

      await this.$dataLoaded();
      if (this.totalCount === 0) {
        this.loadingStatus = ELoadingStatus.NoResults;
      } else {
        this.loadingStatus = ELoadingStatus.Loaded;
      }
    } catch(error) {
      console.error("Error loading data:", error);
      this.loadingStatus = ELoadingStatus.Error;
    }
  }

  async $dataLoaded() {
    const $grid = this;
    const $utils = this.$utils;
    
    this.clearRows();

    if(this.entities) {
      let rowLoadPromises = [];
      for (let entity of this.entities) {
        const row = new FootprintManager_shippingcontents_gridComponentRowModel(
          this,
          this.$utils,
          this.$settings,
          this.$shell, 
          this.$datasources,
          this.$flows,
          this.$reports,
          this.$localization,
          this.$operations,
          this.$logger,
          this.$context);
        rowLoadPromises.push(row.$initializeExisting(entity));
        this.rows.push(row);
      }
      await Promise.all(rowLoadPromises);
    }

  }

  
    async $applyLinkedDatasourcesAndCustomColumns(inParams: any, outParams: any) {
      const $datasource = { inParams: inParams };
      const $utils = this.$utils;
  
    }

  clearRows() {
    if(this.rows && this.rows.length) {
      this.rows.forEach(r => r.destroy());
    }
    this.rows = [];
  }

  selectedRows: FootprintManager_shippingcontents_gridComponentRowModel[] = [];
  hasSelectedRows() {
    return this.selectedRows.length > 0;
  }

  async $selectionChanged(selectedRows: any[]) {
    this.selectedRows = selectedRows;
    await this.on_row_selected();
  }

  
  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }

  //#region private flows
  on_row_selected(event = null) {
    return this.on_row_selectedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_row_selectedInternal(
    $grid: FootprintManager_shippingcontents_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_shippingcontents_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  const orderId = $grid.inParams.orderId;
  const order = (await $datasources.SalesOrders.ds_get_order_by_orderId.get({ orderId: orderId })).result;
  if ($utils.isDefined(order)) {
  
      const orderStatusId = order.OrderStatusId
      // Processing status
      if (orderStatusId == 2) {
          const hasOneSelectedRows = $grid.selectedRows.length === 1;
          const selectedRow = $grid.selectedRows
          let distinctLicensePlates = $grid.rows.map(r => r.entity.LicensePlateId).filter((value, index, self) => self.indexOf(value) === index)
          if (distinctLicensePlates.length > 1) {
              $grid.topToolbar.transfer_to_new_order.control.readOnly = false;
          } else {
              $grid.topToolbar.transfer_to_new_order.control.readOnly = true;
          }
  
          if (hasOneSelectedRows) {
  
              $grid.topToolbar.unpick.control.readOnly = false;
  
              const licenseplateId = selectedRow[0].entity.LicensePlateId;
              const shipmentId = $grid.inParams.shipmentId;
  
              if ($utils.isAllDefined(licenseplateId, shipmentId)) {
                  const loadingTasks = (await $datasources.SalesOrders.ds_get_loading_tasks_by_licenseplateId_shipmentId.get({
                      licenseplateId: licenseplateId,
                      shipmentId: shipmentId
                  })).result;
  
                  // If loading tasks exist then allow the unloading action
                  if ($utils.isDefined(loadingTasks)) {
                      $grid.topToolbar.unload.control.readOnly = false;
                      $grid.topToolbar.transfer_to_new_order.control.readOnly = true;
                  }
                  else {
                      $grid.topToolbar.unload.control.readOnly = true;
                      if (distinctLicensePlates.length > 1) {
                          $grid.topToolbar.transfer_to_new_order.control.readOnly = false;
                      } else {
                          $grid.topToolbar.transfer_to_new_order.control.readOnly = true;
                      }
                  }
              }
          }
          else {
              if ($grid.selectedRows.length > 1) {
                  let loadingTasksCount: number = 0;
                  for (let row of $grid.selectedRows) {
                      const loadingTasks = (await $datasources.SalesOrders.ds_get_loading_tasks_by_licenseplateId_shipmentId.get({
                          licenseplateId: row.entity.LicensePlateId,
                          shipmentId: $grid.inParams.shipmentId
                      })).result;
                      if (!$utils.isDefined(loadingTasks)) {
                          loadingTasksCount = loadingTasksCount + 1
                      }
                  }
                  if ($grid.selectedRows.length == loadingTasksCount) {
                      if (distinctLicensePlates.length > 1) {
                          $grid.topToolbar.transfer_to_new_order.control.readOnly = false;
                      }
                  } else {
                      $grid.topToolbar.transfer_to_new_order.control.readOnly = true;
                  }
              }
              else {
                  $grid.topToolbar.unpick.control.readOnly = true;
                  $grid.topToolbar.unload.control.readOnly = true;
              }
          }
      }
      else {
          $grid.topToolbar.unpick.control.readOnly = true;
          $grid.topToolbar.unload.control.readOnly = true;
          $grid.topToolbar.transfer_to_new_order.control.readOnly = true;
      }
  }
  else {
      $grid.topToolbar.unpick.control.readOnly = true;
      $grid.topToolbar.unload.control.readOnly = true;
      $grid.topToolbar.transfer_to_new_order.control.readOnly = true;
  }
  }
  on_unpick_clicked(event = null) {
    return this.on_unpick_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_unpick_clickedInternal(
    $grid: FootprintManager_shippingcontents_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_shippingcontents_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  const dialogResult = await $shell.FootprintManager.openunpicking_formDialog({
      licenseplateId: $grid.selectedRows[0].entity.LicensePlateId,
      inventory: {
          lotId: $grid.selectedRows[0].entity.LotId,
          packagingId: $grid.selectedRows[0].entity.PackagedId,
          packagedAmount: $grid.selectedRows[0].entity.PackagedAmount,
          shipmentLineId: $grid.selectedRows[0].entity.ShipmentLineId
      }
  });
  const userConfirmed = dialogResult.confirm;
  
  
  
  if (userConfirmed) {
      await $grid.refresh();
  
  }
  }
  on_unload_clicked(event = null) {
    return this.on_unload_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_unload_clickedInternal(
    $grid: FootprintManager_shippingcontents_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_shippingcontents_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  const dialogResult = await $shell.FootprintManager.openunloading_formDialog({
      licenseplateId: $grid.selectedRows[0].entity.LicensePlateId,
      shipmentId: $grid.inParams.shipmentId
  });
  const userConfirmed = dialogResult.confirm;
  
  
  
  if (userConfirmed) {
      await $grid.refresh();
  
  }
  }
  on_transfer_clicked(event = null) {
    return this.on_transfer_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_transfer_clickedInternal(
    $grid: FootprintManager_shippingcontents_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_shippingcontents_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  try {
      //Capture information from original order
      let results = (await $datasources.SalesOrders.ds_get_order_by_licenseplate.get({ LicenseplateId: $grid.rows[0].entity.LicensePlateId })).result[0]
      let originalShipmentInfo = results.Shipment
  
      //launch transfer process
      if ($grid.hasSelectedRows.length > 0) {
          await $shell.FootprintManager.opentransfer_licenseplate_formDialog({ licenseplateIds: $grid.selectedRows.map(r => r.entity.LicensePlateId), sourceShipmentId: originalShipmentInfo.Id })
      } else {
          let loadingTasksCount: number = 0;
          let unloadedLicensePlates: number [] = [];
          for (let row of $grid.rows) {
              const loadingTasks = (await $datasources.SalesOrders.ds_get_loading_tasks_by_licenseplateId_shipmentId.get({
                  licenseplateId: row.entity.LicensePlateId,
                  shipmentId: $grid.inParams.shipmentId
              })).result;
              if (!$utils.isDefined(loadingTasks)) {
                  unloadedLicensePlates.push(row.entity.LicensePlateId)
              }
          }
          await $shell.FootprintManager.opentransfer_licenseplate_formDialog({ licenseplateIds: unloadedLicensePlates, sourceShipmentId: originalShipmentInfo.Id })
      }
      $grid.refresh();
  }
  catch (error) {
      $shell.SalesOrders.openErrorDialog(`Error transfering licenseplates`, `Error transfering licenseplates ${$grid.selectedRows.map(r => r.entity.LicensePlate.LookupCode).join(` ,`)} to a new order`, error)
  }
  }
  on_init(event = null) {
    return this.on_initInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_initInternal(
    $grid: FootprintManager_shippingcontents_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_shippingcontents_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  //$grid.topToolbar.transfer_to_new_order.hidden = true;
  var hasParentContainer: number[] = []
  
  for (let row of $grid.rows){
    hasParentContainer.push(row.entity.LicensePlate?.ShippingContainer?.ParentShippingContainer?.Id)
  }
  if(!$utils.isDefined(hasParentContainer)){
      $grid.headers.parent_shipping_container.hidden = true;
  }
  }
  //#endregion private flows


 
  close() {
    this.$finish.emit();
  }
}
